App.directive('formTpl', ['Config', function (Config) {
    function FormTplCtrl($scope, $rootScope) {
        var self = this;

        self.$onInit = function () {
            $scope.model.sameAddress = !!$scope.addressToApply;
            // @TODO: <HEALTH2019>
            if ($scope.isHealth && !$rootScope.CONFIGURATOR.healthInsurance.canAddSiblings) {
                $scope.withSibling = false;
                $scope.model['member'] = 'CHILD';
            }

            $scope.notExistEmail = !!$scope.isNullableEmail;

            $scope.$watch('notExistEmail', function (oldVal, newVal) {
                if (oldVal !== newVal) {
                    if ($scope.notExistEmail) {
                        $scope.model.email = '';
                    }
                }
            });
            // @TODO: </HEALTH2019>
        };

        self.$onChanges = function (changes) {
            if (changes && changes.addressToApply) {
                $scope.model.sameAddress = !!$scope.addressToApply;
            }
            console.log('[formTpl] [$onChanges]', changes, $scope.model.sameAddress);
        };
    }
    FormTplCtrl.$inject = ['$scope', '$rootScope'];
    return {
    	restrict: 'AEC',
        scope: {
            form: '=',
            model: '=',
            prefix: '@',
            // @TODO <HEALTH2019>
            withSibling: '<?',
            // @TODO </HEALTH2019>
            addressToApply: '<?',
            // @TODO <HEALTH2019>
            isHealth: '<?',
            isNullableEmail: '<?'
            // @TODO </HEALTH2019>
        },
        templateUrl: Config.TEMPLATES_DIR + 'Components/form-tpl.html',
        // @TODO: <HEALTH2019>
        // @TODO: Inject rootScope
        controller: FormTplCtrl
    };
}]);
